export default "__VITE_ASSET__c5b9bc79__"